export class StudentFile {
  id: number
  student_no_character: string
  name: string
  grade: number
  room_name: string
  student_no: number
  is_delete_checked: boolean = false
  is_download_checked: boolean = false
  is_publish: boolean
  is_publish_cache: boolean

  constructor(x: any){
    this.id = x.id;
    this.student_no_character = x.student_no_character;
    this.name = x.name;
    this.grade = x.grade;
    this.room_name = x.room_name;
    this.student_no = x.student_no;
    this.is_publish = x.is_publish;
    this.is_publish_cache = x.is_publish;
  }
}